import { Box, Button, Card, CardContent, Typography } from '@mui/material'
import React from 'react'
import { deleteCookie } from '../utils'

const UnpaidView = () => {
  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Box>
          <Typography>
            Your access has been shut off due to either a canceled subscription
            or a failed payment.
          </Typography>

          <Typography>
            If your subscription has been reenabled, press the button below to
            attempt to log in again.
          </Typography>

          <Button
            sx={{ mt: 2 }}
            variant='contained'
            onClick={() => {
              deleteCookie('access_token')

              window.location.replace('/')
            }}
          >
            Login
          </Button>
        </Box>
      </CardContent>
    </Card>
  )
}

export default UnpaidView
